// extracted by mini-css-extract-plugin
export default {"productGrid":"JZ-z","centerLink":"KZ-z","productSection":"LZ-z","item":"MZ-z","ctaButton":"NZ-z"};